<div class="space-y-4">
	<div class="flex justify-between">
		<app-breadcrumbs [items]="breadcrumbItems" />
		<a
			[routerLink]="['/users/new']"
			class="inline-flex items-center justify-center rounded-xl bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800"
		>
			Create User
		</a>
	</div>

	<section class="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">

		<div class="space-y-4">
            <div class="flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 pb-4">
                <div>
                    <p class="mb-2 text-xs font-semibold uppercase tracking-wide text-slate-500">Role Type</p>
                    <div class="flex flex-wrap gap-2">
                        <button
                            type="button"
                            (click)="setRoleFilter('all')"
							class="filter-chip rounded-lg border px-3 py-1.5 text-sm"
							[class.filter-chip-selected]="roleFilter() === 'all'"
                        >
                            All ({{ roleCounts().all }})
                        </button>
                        <button
                            type="button"
                            (click)="setRoleFilter('admin')"
							class="filter-chip rounded-lg border px-3 py-1.5 text-sm"
							[class.filter-chip-selected]="roleFilter() === 'admin'"
                        >
                            Admin ({{ roleCounts().admin }})
                        </button>
                        <button
                            type="button"
                            (click)="setRoleFilter('dekalb')"
							class="filter-chip rounded-lg border px-3 py-1.5 text-sm"
							[class.filter-chip-selected]="roleFilter() === 'dekalb'"
                        >
                            Dekalb ({{ roleCounts().dekalb }})
                        </button>
                        <button
                            type="button"
                            (click)="setRoleFilter('partner')"
							class="filter-chip rounded-lg border px-3 py-1.5 text-sm"
							[class.filter-chip-selected]="roleFilter() === 'partner'"
                        >
                            Partner ({{ roleCounts().partner }})
                        </button>
                    </div>
                </div>
                <div class="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700">
                    Total users: <span class="font-semibold">{{ totalUsers() }}</span>
                </div>
            </div>

			<div class="grid gap-4 md:grid-cols-[minmax(0,1fr)_auto] md:items-end">
				<div>
					<label for="users-search" class="mb-1 block text-sm font-medium text-slate-700">
						Search by name or email
					</label>
					<input
						id="users-search"
						type="text"
						[ngModel]="search()"
						(ngModelChange)="updateSearch($event)"
						placeholder="Start typing a name..."
						class="w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 outline-none focus:border-slate-500 focus:ring-2 focus:ring-slate-200"
					/>
				</div>

				<div>
					<p class="mb-1 block text-sm font-medium text-slate-700">Status</p>
					<div class="inline-flex rounded-xl border border-slate-300 p-1">
						<button
							type="button"
							(click)="setStatusFilter('all')"
							class="segmented-option rounded-lg px-3 py-1.5 text-sm"
							[class.segmented-option-selected]="statusFilter() === 'all'"
						>
							All ({{ statusCounts().all }})
						</button>
						<button
							type="button"
							(click)="setStatusFilter('enabled')"
							class="segmented-option rounded-lg px-3 py-1.5 text-sm"
							[class.segmented-option-selected]="statusFilter() === 'enabled'"
						>
							Enabled ({{ statusCounts().enabled }})
						</button>
						<button
							type="button"
							(click)="setStatusFilter('disabled')"
							class="segmented-option rounded-lg px-3 py-1.5 text-sm"
							[class.segmented-option-selected]="statusFilter() === 'disabled'"
						>
							Disabled ({{ statusCounts().disabled }})
						</button>
					</div>
				</div>
			</div>
		</div>

		@if (loading()) {
			<div class="mt-5 rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600">
				Loading users...
			</div>
		} @else if (errorMessage()) {
			<div class="mt-5 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
				{{ errorMessage() }}
			</div>
		} @else {
			<div class="mt-5 space-y-3">
				@if (!filteredUsers().length) {
					<div class="rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600">
						No users match the current filters.
					</div>
				}

				@for (user of filteredUsers(); track user.id) {
					<article class="rounded-xl border border-slate-200 p-4 sm:p-5">
						<div class="grid gap-4 lg:grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)_auto] lg:items-center">
							<div class="min-w-0">
								<h2 class="truncate text-base font-semibold text-slate-900">{{ user.fullName }}</h2>
								<p class="mt-1 truncate text-sm text-slate-500">{{ user.email }}</p>
							</div>

							<div class="flex flex-wrap items-center gap-2 lg:justify-end">
								<span class="rounded-full border border-slate-200 bg-slate-50 px-2 py-1 text-xs text-slate-700">
									{{ user.role | titlecase }}
								</span>
								<span
									class="user-state-badge rounded-full border px-2 py-1 text-xs"
									[class.user-state-badge-enabled]="user.isActive"
								>
									{{ user.isActive ? 'Enabled' : 'Disabled' }}
								</span>
							</div>

							<div class="lg:justify-self-end">
								<a
									[routerLink]="['/users', user.id, 'profile']"
									class="inline-flex w-full items-center justify-center rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 lg:w-auto"
								>
									Edit
								</a>
							</div>
						</div>
					</article>
				}
			</div>
		}
	</section>
</div>
